import { type MutationHookOptions, useMutation } from "@apollo/client";
import { StopStreamPullMutation } from "../graphql/mutations";
import type {
  StopStreamPullMutationType,
  StopStreamPullMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useStopStreamPullMutation = (
  options?: MutationHookOptions<
    StopStreamPullMutationType,
    StopStreamPullMutationVariablesType
  >
) => {
  return useMutation<
    StopStreamPullMutationType,
    StopStreamPullMutationVariablesType
  >(StopStreamPullMutation, options);
};
